import React from 'react';
const ModalWrapper = (props)=>{
    return <div className="modal-block">
        <div className="modal-header">
            <h2>{props.title}</h2>
            {!!props.onDelete === true &&
            <div className="modal-header_btn" onClick={props.onDelete}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 25">
                    <g fill="currentColor">
                        <path d="M18.08,3.08H13.85V2.31A2.32,2.32,0,0,0,11.54,0H8.46A2.32,2.32,0,0,0,6.15,2.31v.77H1.92A1.92,1.92,0,0,0,0,5V7.69a.76.76,0,0,0,.77.77h.42l.66,14a2.32,2.32,0,0,0,2.31,2.2H15.84a2.32,2.32,0,0,0,2.31-2.2l.66-14h.42A.76.76,0,0,0,20,7.69V5a1.92,1.92,0,0,0-1.92-1.92ZM7.69,2.31a.77.77,0,0,1,.77-.77h3.08a.77.77,0,0,1,.77.77v.77H7.69ZM1.54,5a.38.38,0,0,1,.38-.38H18.08a.38.38,0,0,1,.38.38V6.92H1.54ZM16.61,22.34a.77.77,0,0,1-.77.74H4.16a.77.77,0,0,1-.77-.74L2.73,8.46H17.27Z"></path>
                        <path d="M10,21.54a.78.78,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.78.78,0,0,0,10,21.54Z"></path>
                        <path d="M13.85,21.54a.78.78,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.77.77,0,0,0,13.85,21.54Z"></path>
                        <path d="M6.15,21.54a.77.77,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.78.78,0,0,0,6.15,21.54Z"></path>
                    </g>
                </svg>
            </div>
            }
            {!!props.onClose === true &&
            <div className="modal-header_btn" onClick={props.onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
                    <g stroke="currentColor">
                        <line x1="1" y1="1" x2="18" y2="18"></line>
                        <line x1="18" y1="1" x2="1" y2="18"></line>
                    </g>
                </svg>
            </div>
            }
        </div>
        {props.children}
        </div>
}
export default ModalWrapper